import { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useLocalStorage } from "@uidotdev/usehooks"

const useSharePointToken = () => {
    const location = useLocation()

    const [loading, setLoading] = useState(true)
    const [tokenIsValid, setTokenIsValid] = useState(false)
    const [encryptionKey, setEncryptionKey] = useLocalStorage("sharepoint_encryption_key", "")

    useEffect(() => {
        if( encryptionKey === "" ) {
            setEncryptionKey( newEncryptionKey() )
        }
    }, [])

    useEffect(() => {
        validateToken()
    }, [encryptionKey])
    
    const newEncryptionKey = () => {
        const randomString = [...crypto.getRandomValues(new Uint8Array(16))]
            .map(b => b.toString(16).padStart(2, '0'))
            .join('');
        return randomString
    };
    
    const validateToken = async () => {
        const response = await fetch('/v0/sharepoint/token/validate?encryption_key=' + encryptionKey, { credentials: 'same-origin' })
        const json = await response.json()
        setTokenIsValid(json.is_valid)
        setLoading(false)
    };

    const redirectToAuthUrl = () => {
        const current = location.pathname
        fetch('/v0/sharepoint/token/auth_url?redirect_url=' + current + '&encryption_key=' + encryptionKey, { credentials: 'same-origin' })
            .then(function(response) {
                if (!response.ok) throw response
                return response.json()
            })
            .then(function(json) {
                window.location.href = json.auth_url
            })
            .catch(error => console.log("OAuth login error", error))
    }
    
    return {
        tokenIsValid,
        encryptionKey,
        redirectToAuthUrl,
        loading,
    }
}

export default useSharePointToken
